import HtmlColors from 'html-colors' // all HTML color names
import Color from 'color' // to find out a color is too light for text
import MersenneTwister from 'mersenne-twister'

class ColorCoding {
    constructor(options) {
        this.map = {}
        this.used = {}
        this.usedCount = 0
        this.colorNames = (options && options.light)
            ? ColorCoding.getColors((n) => Color(n).isLight())
            : (
                (options && options.dark)
                ? ColorCoding.getColors((n) => Color(n).isDark())
                : ColorCoding.getColors()
            )
        this.numberOfColorNames = this.colorNames.length
        this.randomGenerator = new MersenneTwister()

        this.getRandomColor = this.getRandomColor.bind(this)
    }

    getColor(name) {
        if (this.map[name]) {
            return this.map[name]
        }

        if (this.usedCount === this.numberOfColorNames) {
            return "gray"
        }

        var colorName = this.getRandomColor()
        while(this.used[colorName]) {
            colorName = this.getRandomColor()
        }

        this.map[name] = colorName
        this.used[colorName] = true
        this.usedCount += 1
        return colorName
    }

    getRandomColor() {
        return this.colorNames[Math.floor(this.randomGenerator.random() * this.numberOfColorNames)]
    }

    getTextColor(name) {
        const colorName = this.map[name]
        if (!colorName || Color(colorName).isDark()) {
            return 'white'
        }
        return 'black'
    }

    static getColors(func) {
        func = func || (() => true)
        const result = []
        for (var colorName of HtmlColors.names()) {
            if (func(colorName)) {
                result.push(colorName)
            }
        }
        return result
    }
}

export default ColorCoding
